import { createSlice, current } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

let fakeDataCaptivePortal = [
  {
    id: 'c8f9e1d2-a3b4-5678-9012-345678901234',
    name: 'Guest Portal',
    authType: 'CLICK_THROUGH',
    idleTimeout: 60,
    idleTimeoutOption: 'DEFAULT',
    authTimeout: 0,
    authTimeoutOption: 'DISABLE',
    authPerDay: 720,
    authPerDayOption: 'CUSTOM',
    reAuthInterval: 0,
    reAuthIntervalOption: 'DISABLE',
    landingPageOption: 'NO_SPECIFIC',
    landingPageUrl: '',
    macWhiteList: 'mac-group-001',
  },
  {
    id: 'd9g0f2e3-b4c5-6789-0123-456789012345',
    name: 'Staff Portal',
    authType: 'CLICK_THROUGH',
    idleTimeout: 1440,
    idleTimeoutOption: 'CUSTOM',
    authTimeout: 480,
    authTimeoutOption: 'ENABLE',
    authPerDay: 0,
    authPerDayOption: 'UNLIMIT',
    reAuthInterval: 30,
    reAuthIntervalOption: 'ENABLE',
    landingPageOption: 'CUSTOM',
    landingPageUrl: 'https://example.com/welcome',
    macWhiteList: null,
  },
];

const initialState = {
  resource: 'captivePortal',
  data: [],
};

export const captivePortalSlice = createSlice({
  name: 'captivePortal',
  initialState,
  reducers: {
    initCaptivePortal: (state, _) => {
      state.data = [...fakeDataCaptivePortal];
    },
    addCaptivePortal: (state, action) => {
      // console.log('Add captive portal: ', action.payload);
      if (!action?.payload?.id) {
        action.payload['id'] = uuidv4();
      }
      state.data.push(action.payload);
    },
    updateCaptivePortal: (state, action) => {
      // console.log('Update captive portal: ', action.payload);
      // console.log('reducer:', action.type, current(state));
      const index = state.data.findIndex(p => p.id === action.payload.id);
      if (index !== -1) {
        state.data[index] = {
          ...state.data[index],
          ...action.payload,
        };
      }
    },
    deleteCaptivePortal: (state, action) => {
      // console.log('Delete captive portal: ', action.payload);
      const { captivePortalIds } = action.payload;
      state.data = state.data.filter(item => !captivePortalIds.includes(item.id));
    },
  },
});

export const { initCaptivePortal, addCaptivePortal, updateCaptivePortal, deleteCaptivePortal } = captivePortalSlice.actions;

export default captivePortalSlice.reducer;
